import script from "./PrintOrderInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintOrderInfo.vue?vue&type=script&lang=ts&setup=true"

import "./PrintOrderInfo.vue?vue&type=style&index=0&id=7341a550&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7341a550"]])

export default __exports__